module.exports = __webpack_public_path__ + "img/Speaker=Zach Latta.5274c8f9.png";